import React from "react";
import { Card, NumField, inr, unitPrice } from "./PricingUi";

export const CostCard = ({ p, set }) => {
  const unit = unitPrice(p.base_cost_inr, p.markup_pct);
  const profit = unit - Number(p.base_cost_inr || 0);
  return (
    <Card title="Your cost & markup" testid="pricing-cost-card"
      desc="Every build your users run is paid from your Emergent balance. Enter what one credit costs you there — user prices are worked out automatically with your markup on top.">
      <div className="grid sm:grid-cols-2 gap-4">
        <NumField label="Your Emergent cost per credit" prefix="₹" step={0.01} value={p.base_cost_inr} onChange={(v) => set({ base_cost_inr: v })}
          testid="pricing-base-cost-input" hint="Emergent sells 100 credits for $20 — about ₹17 per credit" />
        <NumField label="Your markup" suffix="%" step={1} value={p.markup_pct} onChange={(v) => set({ markup_pct: v })} testid="pricing-markup-input"
          hint="20% means users pay your cost + 20%" />
      </div>
      <div className="mt-5 grid grid-cols-3 gap-3 text-center">
        {[["You pay Emergent", inr(p.base_cost_inr, 2), "text-slate-900", "pricing-unit-cost"], ["Users pay you", inr(unit, 2), "text-sky-700", "pricing-unit-price"],
          ["Your profit", inr(profit, 2), "text-emerald-700", "pricing-unit-profit"]].map(([l, v, c, t]) => (
          <div key={l} className="rounded-2xl bg-slate-50 p-3 sm:p-4">
            <div className="text-[11px] text-slate-500">{l}</div>
            <div className={`mt-1 font-display text-lg sm:text-2xl font-bold ${c}`} data-testid={t}>{v}</div>
            <div className="text-[10px] text-slate-400">per credit</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default CostCard;
